import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Box, Typography, Button } from '@material-ui/core'
import axios from 'axios'

export default function MissingWorkforce(props) {
    const [selectedFile, setSelectedFile] = useState(false)
    const [errorMessage, setErrorMessage] = useState(false)
    const [uploadingInProgress, setUploadingInProgress] = useState(false)

    const uploadFile = () => {
        console.log('upload file clicked')
        setUploadingInProgress(true)
        const data = new FormData()
		data.append('media_file', selectedFile)
		data.append('forecast_id', props.selectedForecast.value)
        axios.post('/api/importWorkforceFile', data).then(res => {
            setUploadingInProgress(false)
            if(res.data.status) {
                props.onWorkforceUpload()
            } else {
                setErrorMessage('Sorry, we are unable to process your file.')
            }
        })
    }

    return (
        <>
            <Typography gutterBottom display='inline' color='textSecondary' >
                Please make sure that you are going to upload filled template
                file. If not then please download the template file first.
            </Typography>
            <Button size="small" onClick={() => props.onDownloadTemplate()} color='primary'>
                (Download Template)
            </Button>
            <Box m={2} display="flex" justifyContent="center">
            </Box>
            <Typography variant='h4' gutterBottom>Select Filled Template File(xlsx) to upload Workforce</Typography>
            <Typography color='error'>{errorMessage}</Typography>
            <Box m={2} display="flex" justifyContent="center">
                <input
                    type="file"
                    className="custom-file-input"
                    id="inputGroupFile01"
                    aria-describedby="inputGroupFileAddon01"
                    onChange={(e) => setSelectedFile(e.target.files[0])}
                />
            </Box>
            <Box m={2} display="flex" justifyContent="center">
                <Button
                    variant="contained"
                    onClick={uploadFile}
                    disabled={!selectedFile || uploadingInProgress}
                >
                    Upload
                </Button>
            </Box>
            <Box m={2} display="flex" justifyContent="center">
                {uploadingInProgress ? <span>Uploading...</span> : null }
            </Box>
        </>
    )
}

MissingWorkforce.propTypes = {
    onWorkforceUpload: PropTypes.func.isRequired,
	onDownloadTemplate: PropTypes.func.isRequired,
	selectedForecast: PropTypes.object.isRequired,
}
